export const saveFilterState = (filterState, storageKey = 'placementFilterState') => {
  try {
    const stateToSave = {
      ...filterState,
      timestamp: new Date().toISOString()
    };
    localStorage.setItem(storageKey, JSON.stringify(stateToSave));
    console.log(`Filter state saved for ${storageKey}:`, stateToSave);
  } catch (error) {
    console.error(`Error saving filter state for ${storageKey}:`, error);
  }
};

export const loadFilterState = (storageKey = 'placementFilterState') => {
  try {
    const savedState = localStorage.getItem(storageKey);
    if (savedState) {
      const parsedState = JSON.parse(savedState);
      console.log(`Filter state loaded for ${storageKey}:`, parsedState);
      return parsedState;
    }
    return null;
  } catch (error) {
    console.error(`Error loading filter state for ${storageKey}:`, error);
    return null;
  }
};

export const clearFilterState = (storageKey = 'placementFilterState') => {
  try {
    localStorage.removeItem(storageKey);
    console.log(`Filter state cleared for ${storageKey}`);
  } catch (error) {
    console.error(`Error clearing filter state for ${storageKey}:`, error);
  }
};